import React from 'react';
import { connect } from "react-redux";
import { updateData } from "../actions";
import ControlService from "../../helper/controlservice";

class Password extends React.PureComponent {
    state = {
        touched: false,
        value: ''
    }
    static getDerivedStateFromProps(nextProps) {
        const { control, formid, data } = nextProps;
        var _data = data[formid] && data[formid][control.key] ? data[formid][control.key] : ""
        return {
            value: _data
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.value && this.state.value != prevState.value) {
            ControlService().controlVaildationCheck(this.props);
        }
    }
    componentDidMount() {
        ControlService().controlVaildationCheck(this.props);
    }
    handleBlur = () => {
        this.setState({
            touched: true,
        });
    }
    shouldMarkError(control, data) {
        const validate = ControlService().validate(control, data[control.key]);

        const validation = this.props.data[this.props.formid + "_validation"] ? this.props.data[this.props.formid + "_validation"][control.key] : null;
        const isTouchedOutside = validation ? validation.touched : false;
        const shouldShow = this.state.touched || isTouchedOutside;
        return validate ? !validate : shouldShow;
    }

    render() {
        const { control, formid } = this.props;
        var data = this.props.data[formid] ? this.props.data[formid] : {};
        const shouldMarkError = this.shouldMarkError(control, data);
        return (
            <div className="form-group">
                {control.label &&
                    <label>
                        {control.label}
                        {control.require &&
                            <sup className="text-danger font-weight-bold">*</sup>
                        }
                        {control.showhelptext &&
                            <span className={"custom-tooltip"}>
                                <i className={"fa fa-question-circle ml-2 help-text"}></i>
                                <span className={"tooltip tooltip-" + control.helpdirection}>{control.help}</span>
                            </span>
                        }
                    </label>
                }
                <input
                    className={'form-control ' + (shouldMarkError ? "border-danger" : "")}
                    aria-label={control.label}
                    onBlur={() => { this.handleBlur(); }}
                    type="password" placeholder={control.placeholder}
                    onChange={(e) => this.props.update(control.key, e.target.value, formid)}
                    value={this.props.data[formid][control.key]}
                    disabled={this.props.disabled}
                />
                {shouldMarkError &&
                    <small className="form-text text-danger">
                        {control.errormsg ? control.errormsg : 'You must enter a ' + control.label + '.'}
                    </small>
                }
            </div>
        );
    }
}
function bindAction(dispatch) {
    return {
        update: (key, value, storekey) => dispatch(updateData(key, value, storekey))
    };
}
const mapStateToProps = state => ({
    data: state.formDataReducer,
    hasErrored: state.formDataReducer.hasErrored,
    isLoading: state.formDataReducer.isLoading
});
export default connect(mapStateToProps, bindAction)(Password);